import { getAnalytics } from 'firebase/analytics';
import { FirebaseApp, initializeApp } from 'firebase/app';
import { browserLocalPersistence, getAuth } from 'firebase/auth';
import { Firestore, getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

// TODO: Replace the following with your app's Firebase project configuration
const firebaseConfig = {
  apiKey: 'AIzaSyCr0wG_BzoNbrU0dd6ROMLAONVXxIBi0bY',
  authDomain: 'tp-games-de990.firebaseapp.com',
  projectId: 'tp-games-de990',
  storageBucket: 'tp-games-de990.appspot.com',
  messagingSenderId: '292014191253',
  appId: '1:292014191253:web:92f600691500a9c04a219c',
  measurementId: 'G-GXVHFZPF7X',
};

// Initialize Firebase app with error handling
let firebaseApp: FirebaseApp;
try {
  console.log('Initializing Firebase app...');
  firebaseApp = initializeApp(firebaseConfig);
  console.log('Firebase app initialized successfully:', firebaseApp.name);
} catch (error) {
  console.error('Failed to initialize Firebase app:', error);
  throw error;
}

// Initialize services with error handling
let firebaseDb: Firestore | null = null;
let analytics: ReturnType<typeof getAnalytics> | null = null;

// Initialize Firestore with retry logic
const initializeFirestore = async (): Promise<Firestore | null> => {
  try {
    console.log('Initializing Firebase services...');
    console.log('Firebase config:', {
      projectId: firebaseConfig.projectId,
      authDomain: firebaseConfig.authDomain,
      // Don't log sensitive data like apiKey
    });
    
    // Wait a bit to ensure Firebase app is fully ready
    await new Promise(resolve => setTimeout(resolve, 100));
    
    const db = getFirestore(firebaseApp);
    console.log('Firestore initialized successfully');
    
    // Test if we can access Firestore
    console.log('Firestore app:', db.app.name);
    
    return db;
  } catch (error) {
    console.error('Failed to initialize Firestore:', error);
    console.error('Error details:', {
      name: error instanceof Error ? error.name : 'Unknown',
      message: error instanceof Error ? error.message : String(error),
      stack: error instanceof Error ? error.stack : undefined
    });
    console.error('This might be because:');
    console.error('1. Firestore is not enabled in your Firebase project');
    console.error('2. Network connectivity issues');
    console.error('3. Invalid Firebase configuration');
    console.error('4. Firebase project does not exist or is not accessible');
    console.error('5. Firebase SDK version compatibility issues');
    
    // Additional debugging info
    console.error('Current environment:', {
      userAgent: navigator.userAgent,
      online: navigator.onLine,
      location: window.location.href
    });
    
    return null;
  }
};

// Initialize Firestore asynchronously
initializeFirestore().then(db => {
  firebaseDb = db;
});

try {
  analytics = getAnalytics(firebaseApp);
  console.log('Analytics initialized successfully');
} catch (error) {
  console.warn('Failed to initialize Analytics (this is normal in some environments):', error);
}

// Export the services (firebaseDb might be null if initialization failed)
export { firebaseApp, firebaseDb, analytics };

// DEBUG: Connect app to local Firebase emulators
// connectFirestoreEmulator(firebaseDb, 'localhost', 8080);
export const firebaseAuth = getAuth(firebaseApp);
// connectAuthEmulator(firebaseAuth, 'http://localhost:9099');
export const firebaseFunctions = getFunctions(firebaseApp);
// connectFunctionsEmulator(firebaseFunctions, 'localhost', 5001);

export const firebasePersistencePromise = firebaseAuth.setPersistence(
  browserLocalPersistence,
);

// Helper function to check if Firestore is available
export const isFirestoreAvailable = (): boolean => {
  return firebaseDb !== null;
};

// Helper function to get Firestore with error handling
export const getFirestoreInstance = () => {
  if (!firebaseDb) {
    throw new Error('Firestore is not available. Please check your Firebase configuration and ensure Firestore is enabled in your Firebase project.');
  }
  return firebaseDb;
};

// Helper function to wait for Firestore to be ready
export const waitForFirestore = async (timeoutMs: number = 5000): Promise<Firestore> => {
  const startTime = Date.now();
  
  while (!firebaseDb && (Date.now() - startTime) < timeoutMs) {
    await new Promise(resolve => setTimeout(resolve, 100));
  }
  
  if (!firebaseDb) {
    throw new Error(`Firestore initialization timed out after ${timeoutMs}ms`);
  }
  
  return firebaseDb;
};
